import { render } from "./VueScheduler.vue?vue&type=template&id=03ff3cf0&ts=true"
import script from "./VueScheduler.vue?vue&type=script&lang=ts"
export * from "./VueScheduler.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__